import { createSlice } from '@reduxjs/toolkit';

const RegistrationScanSlice = createSlice({
    name: 'RegistrationScanSlice',
    initialState:{
        scanCompleted: false,
        ScanInputs: {
            status: '',
            quantityMaterial: '',
            research: '',
            id: '',
            type: ''
        }
    },
    reducers: {
        ScanCompleted: (state,action) =>{
            state.scanCompleted = true
            state.ScanInputs = action.payload.credential
        },
        ClearInputs: (state) =>{
            state.scanCompleted = false
            state.ScanInputs = {
                status: '',
                quantityMaterial: '',
                research: '',
                id: ''
            }
        },
        updateInput: (state) => {
            state.ScanInputs.quantityMaterial = state.ScanInputs.quantityMaterial + 1
        }
    }
})

export const {ScanCompleted, ClearInputs, updateInput} = RegistrationScanSlice.actions;
export default RegistrationScanSlice;